<ng-container *ngFor="let preset of userPresets">
  <div class="d-flex frame-setup-container" style="cursor: pointer;"
  (click)="openFrameSetup(frameSetup,preset)">
  <div class="frame-content" style="overflow: hidden;">
    <p translate>settings.preset<span style="font-weight: bold;">: {{preset?.name}}</span></p>
    <p translate><span style="font-weight: bold;" translate>{{preset?.assignedFrames.length ? 'settings.assignedFrames' : 'settings.noFrames'}}</span></p>
    <ng-container *ngIf="preset?.assignedFrames.length; else setUpFrames">
      <div style="display: flex; gap: 12px; overflow: auto; margin-top: 8px;">
        <img *ngFor="let frame of preset.assignedFrames" class="frame-preview"
          [src]="(frame?.framePreview != null) ? frame?.framePreview : '/assets/img/no-image.png'" />
      </div>
    </ng-container>

    <ng-template #setUpFrames>
      <p translate><span style="font-weight: bold; font-style: italic;" translate>settings.clickToSetupFrame</span></p>
    </ng-template>
  </div>
</div>
</ng-container>


<ng-template #frameSetup let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">{{selectedFrameSetup.name}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" style="display: flex !important;">
      <!-- TODO: ovo nece moci ovako sad sa novom logikom, ili da se izbaci ili da se smisli nesto -->
      <!-- <div *ngIf="!staticImage" class="d-flex target-setup" style="padding: 10px 5px 10px 15px;">
        <p translate>user.selectAll</p>
        <div>
          <label class="switch">
            <input type="checkbox" [ngModel]="selectedFrameSetup.isSelectedAll"
              (change)="selectAllFrame(selectedFrameSetup)">
            <span class="slider round"></span>
          </label>
        </div>
      </div> -->
      <div class="info-container" *ngIf="selectedFrameSetup.framePositions.length && staticImage">
        <p>Positions with frame: <span>{{selectedFrameSetup.framePositions.join(', ')}}</span></p>
      </div>
      <div class="info-container" *ngIf="selectedFrameSetup.staticImagePositions.length && !staticImage">
        <p>Positions with static images: <span>{{selectedFrameSetup.staticImagePositions.join(', ')}}</span></p>
      </div>
      <ng-container *ngFor="let target of selectedFrameSetup.targets">
        <ng-container *ngIf="!staticImage; else staticSetup">
          <ng-container *ngIf="!target.useStaticFile">
            <div class="d-flex target-setup" style="padding: 8px 5px;">
              <div *ngIf="!(target.staticFile && target.useStaticFile)" class="root-application-bg"
                style="width: 60px; min-height: initial;"
                [style.background-image]="(target?.tutorialFile != null) ? 'url(' + target?.tutorialFile?.fileInfo.path + ')' : 'url(assets/img/no-image.png)'">
              </div>
  
              <div style="display: flex; flex-direction: column; justify-content: center;">
                <p>Position {{target.position}}</p>
                <p style="font-size: .9rem;">{{target.clearType}}</p>
              </div>
  
              <div>
                <img [src]="(target?.framePreview && target.useFrame) ? target?.framePreview : '/assets/img/no-image.png'"
                  alt="" (click)="onSelectTarget(target)"
                  style="width: 60px; min-height: initial; height: 100%; cursor: pointer;"
                  class="root-application-bg frame-image">
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #staticSetup>
          <ng-container *ngIf="!target.useFrame">
            <div class="d-flex target-setup" style="padding: 8px 5px; align-items: center;">
              <div *ngIf="!(target.staticFile && target.useStaticFile)" class="root-application-bg"
                style="width: 60px; height: 100%;"
                [style.background-image]="(target?.tutorialFile != null) ? 'url(' + target?.tutorialFile?.fileInfo.path + ')' : 'url(assets/img/no-image.png)'">
              </div>
              <div *ngIf="target.staticFile && target.useStaticFile" class="root-application-bg"
                style="width: 60px; height: 100%;"
                [style.background-image]="'url(' + target?.staticFile?.thumbnailPath + ')'">
                <button class="upload-btn" *ngIf="target.useStaticFile && staticImage"
                  (click)="openUploadImage(target)"><i class="fa fa-upload"
                    aria-hidden="true"></i></button>
              </div>
    
              <div style="display: flex; flex-direction: column; justify-content: center;">
                <p>Position {{target.position}}</p>
                <p style="font-size: .9rem;">{{target.clearType}}</p>
              </div>
    
              <div>
                <label *ngIf="staticImage" class="switch">
                  <input type="checkbox" [(ngModel)]="target.useStaticFile" (change)="handleChange(target)">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </ng-container>

        </ng-template>
      </ng-container>
    </div>
  </div>
</ng-template>


<app-modal [priority]="true" (close)="closeFileUpload()" *ngIf="toggleSelectFile">
  <div class="modal_container black-text">
    <div class="modal-header">
      <h4 class="modal-title">Upload image</h4>
    </div>
    <div class="modal-body">
      <span style="font-size: 0.85rem;">You need to upload image first.</span>
      <div class="d-flex flex-column" style="display: flex !important;">
        <input type="file" name="image" ngModel (change)="getFile($event)" placeholder="Choose Image" />
        <div class="bg-files bg-hover" *ngIf="previewImage != null"
          [style.background-image]="'url(' + previewImage + ')'"></div>
      </div>
    </div>
    <span class="loading-text d-flex justify-content-center" *ngIf="isAddingStaticFile">Adding static file...</span>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark btn-no" [disabled]="isAddingStaticFile" (click)="closeFileUpload()">CANCEL</button>
      <button type="button" class="btn btn-outline-dark btn-yes" [disabled]="!fileToUpload || isAddingStaticFile" (click)="useStaticFile()">ENABLE</button>
    </div>
  </div>
</app-modal>

<app-modal [priority]="true" (close)="toggleSelectFrame = false" *ngIf="toggleSelectFrame">
  <div class="modal_container black-text">
    <p class="text-header-modal" translate>settings.chooseFrame</p>

    <div class="d-flex frames-container">
      <div>
        <div class="frame-img" [style.border]="(!target.frameId) ? '2px solid red' : null"
          (click)="addFrameOnTarget(null)" [style.background-image]="'url(assets/img/no-image.png)'">
        </div>
        <p translate>user.noFrame</p>
      </div>
      <div *ngFor="let frame of frames">
        <div class="frame-img" (click)="addFrameOnTarget(frame)"
          [style.border]="(target.frameId === frame.id && target.useFrame) ? '2px solid red' : null"
          [style.background-image]="(frame?.preview != null) ? 'url(' + frame?.preview + ')' : 'url(assets/img/no-image.png)'">
        </div>
        <p>{{frame.name}}</p>
      </div>
    </div>

    <div class="loading-text" *ngIf="isAddingFrame" translate>settings.addingFrameMessage</div>
  </div>
</app-modal>